module.exports = {"type":"object","properties":{"name":{},"regExp":{},"context":{"type":"string"},"publicPath":{},"outputPath":{},"useRelativePath":{"type":"boolean"},"emitFile":{"type":"boolean"}},"additionalProperties":true}


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/options.json
// module id = ejoV
// module chunks = 37